import React from 'react'
import {
    AppDownloadImageSection,
    StyledAppDownloadImage,
} from './TNAppDownloadImage.styled'

export function TNAppDownloadImage() {
    const theNightlyAppDownloadImage = require<string>('../assets/thenightly_app_download_image.webp')
    return (
        <AppDownloadImageSection>
            <StyledAppDownloadImage
                src={theNightlyAppDownloadImage}
                alt="Download The Nightly Mobile App"
            />
        </AppDownloadImageSection>
    )
}
